module.exports = __webpack_public_path__ + "static/media/phdiary.429e8720.ipynb";